import { ImporterProccessDocument } from 'generated/resources/graphql'
import moment from 'moment'

import { useQuery } from 'modules/core/hooks/useQuery'

interface Props {
  companyId: number
  accessId: number
}

const FIVE_DAYS_AGO = moment().subtract(5, 'days')

export const useGetSubmittedImporterProcess = ({ companyId, accessId }: Props) => {
  const { data, loading } = useQuery(ImporterProccessDocument, {
    variables: {
      accessId,
      state: 'started',
      companyId,
      updatedAtGteq: FIVE_DAYS_AGO.toISOString(),
    },
  })

  return {
    loading,
    importerProcess: data?.importers.importerProcessesConnection.nodes[0],
    importerActivity:
      data?.importers.importerProcessesConnection.nodes[0]?.activitiesConnection.nodes[0],
  }
}
